import { render, staticRenderFns } from "./m-total.vue?vue&type=template&id=129d14fe&"
import script from "./m-total.vue?vue&type=script&lang=js&"
export * from "./m-total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports